(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuzzle-premium"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('nuzzle-premium')){
  customElements.define('nuzzle-premium',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.abort=new AbortController();const opts={signal:this.abort.signal};
      this.slides=[...this.querySelectorAll('[data-slide]')];this.thumbs=[...this.querySelectorAll('[data-thumb]')];this.index=Math.max(0,this.slides.findIndex(s=>!s.hidden));this.dialog=this.querySelector('dialog');this.zoomImage=this.querySelector('[data-zoom-image]');this.canvas=this.querySelector('.np-lightbox-canvas');this.scale=1;
      this.thumbs.forEach((b,i)=>b.addEventListener('click',()=>this.show(i),opts));this.slides.forEach(b=>b.addEventListener('click',()=>this.open(),opts));this.querySelector('[data-open-zoom]')?.addEventListener('click',()=>this.open(),opts);
      this.querySelector('[data-close]').addEventListener('click',()=>this.dialog.close(),opts);this.dialog.addEventListener('close',()=>{document.documentElement.style.overflow=this.oldOverflow||'';this.opener?.focus();},opts);
      this.querySelector('[data-zoom-in]').addEventListener('click',()=>this.zoom(this.scale+1),opts);this.querySelector('[data-zoom-out]').addEventListener('click',()=>this.zoom(this.scale-1),opts);this.zoomImage.addEventListener('click',()=>this.zoom(this.scale===1?2:1),opts);
      this.querySelector('[data-previous]').addEventListener('click',()=>this.show(this.index-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>this.show(this.index+1),opts);
      this.dialog.addEventListener('keydown',e=>{if(e.key==='ArrowRight'&&this.scale===1){e.preventDefault();this.show(this.index+1);}if(e.key==='ArrowLeft'&&this.scale===1){e.preventDefault();this.show(this.index-1);}},opts);
      const stage=this.querySelector('[data-stage]');let start;
      stage.addEventListener('pointerdown',e=>{if(e.pointerType==='touch')start={x:e.clientX,y:e.clientY};},opts);
      stage.addEventListener('pointerup',e=>{if(!start)return;const dx=e.clientX-start.x,dy=e.clientY-start.y;start=null;if(Math.abs(dx)>55&&Math.abs(dx)>Math.abs(dy)*1.5){this.swiped=Date.now();this.show(this.index+(dx<0?1:-1));}},opts);stage.addEventListener('pointercancel',()=>{start=null;},opts);
      this.querySelectorAll('input[name="id"]').forEach(r=>r.addEventListener('change',()=>{this.querySelectorAll('.np-prices [data-price]').forEach(p=>p.textContent=r.dataset.price);this.querySelectorAll('[data-cta-price]').forEach(p=>p.textContent='— '+r.dataset.price);this.querySelectorAll('.np-prices [data-compare]').forEach(p=>p.textContent=r.dataset.compare||'');this.querySelectorAll('[data-compare-wrap]').forEach(p=>p.hidden=!r.dataset.compare);const n=this.slides.findIndex(s=>s.dataset.imageId===r.dataset.photo);if(n>=0)this.show(n);},opts));
      const input=this.querySelector('.np-name input'),form=this.querySelector('form'),buy=this.querySelector('.np-buy'),label=this.querySelector('[data-buy-label]');
      if(input){const refresh=()=>{this.querySelector('[data-count]').textContent=input.value.length+'/18';this.querySelector('[data-name-preview]').textContent=input.value;this.querySelector('[data-review]').hidden=!input.value.trim();input.setCustomValidity(input.value&&!input.value.trim()?this.dataset.invalid:'');};input.addEventListener('input',refresh,opts);refresh();
        form.addEventListener('submit',e=>{input.value=input.value.trim();refresh();if(!form.checkValidity()){e.preventDefault();form.reportValidity();return;}if(this.submitting){e.preventDefault();return;}this.submitting=true;buy.setAttribute('aria-busy','true');this.querySelector('[data-sticky-buy]')?.setAttribute('disabled','');this.originalLabel=label.textContent;label.textContent=this.dataset.adding;},opts);
        input.addEventListener('invalid',()=>{input.scrollIntoView({block:'center'});},opts);
        window.addEventListener('pageshow',()=>{this.submitting=false;buy.removeAttribute('aria-busy');this.querySelector('[data-sticky-buy]')?.removeAttribute('disabled');if(this.originalLabel)label.textContent=this.originalLabel;},opts);
        const sticky=this.querySelector('[data-sticky]');if(sticky&&'IntersectionObserver'in window){this.observer=new IntersectionObserver(entries=>{sticky.hidden=entries[0].isIntersecting||buy.getBoundingClientRect().bottom>0;document.body.classList.toggle('np-sticky-visible',!sticky.hidden);},{threshold:0});this.observer.observe(buy);}
      }
      if(this.slides.length)this.show(this.index);
      
    }
    show(n){if(!this.slides.length)return;this.index=(n+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>s.hidden=i!==this.index);this.thumbs.forEach((b,i)=>b.setAttribute('aria-pressed',String(i===this.index)));this.querySelector('[data-counter]').textContent=(this.index+1)+' / '+this.slides.length;if(this.dialog.open)this.fillZoom();}
    open(){if(Date.now()-(this.swiped||0)<400||!this.slides.length)return;this.opener=document.activeElement;this.oldOverflow=document.documentElement.style.overflow;this.fillZoom();this.dialog.showModal();document.documentElement.style.overflow='hidden';}
    fillZoom(){const img=this.slides[this.index].querySelector('img');this.zoomImage.src=img.src;this.zoomImage.alt=img.alt;this.querySelector('[data-modal-caption]').textContent=(this.index+1)+' / '+this.slides.length+' — '+img.alt;this.zoom(1);}
    zoom(n){this.scale=Math.max(1,Math.min(3,n));this.canvas.classList.toggle('is-zoomed',this.scale>1);this.canvas.style.setProperty('--zoom',this.scale*100+'%');this.querySelector('[data-level]').textContent=this.scale*100+'%';this.querySelector('[data-zoom-out]').disabled=this.scale===1;this.querySelector('[data-zoom-in]').disabled=this.scale===3;this.canvas.scrollTo(0,0);}
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();clearInterval(this.offerInterval);clearTimeout(this.activityExpiry);if(this.dialog?.open){this.dialog.close();document.documentElement.style.overflow=this.oldOverflow||'';}document.body.classList.remove('np-sticky-visible');this.ready=false;}
  });
}

  } catch(e) { console.error(e); }
})();
})();
